import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type TeamSourcesAssignments = {
   assignments: TeamSourcesAssignment[];
};

export type TeamSourcesAssignment = {
   teamid: number;
   team_name: string;
   created_date: number;
   assigner_name: string;
   assigner_userid: number;
   course_assignmentid: number;
};

export type GetTeamSourcesAssignmentsOptions = CommonRequestOptions & {
   teamid: number;
   wikiid?: number;
};

export async function getTeamSourcesAssignments({
   wikiid,
   teamid,
   ...common
}: GetTeamSourcesAssignmentsOptions): Promise<TeamSourcesAssignments> {
   return makeRequest('get', `/course_assignments/sources/team/${teamid}`, {
      ...common,
      query: {
         wikiid,
      },
   });
}
